import React from 'react';
import EventLabel from './EventLabel/EventLabel';

export function DeadlineDue() {
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-center justify-center items-center flex flex-col ">
        <img
          className="w-64"
          src="https://static.vecteezy.com/system/resources/previews/006/126/498/original/day-or-date-reminder-with-calendar-concept-illustration-flat-design-eps10-modern-graphic-element-for-landing-page-empty-state-ui-infographic-icon-vector.jpg"
        />

        <div className="flex flex-col items-center justify-center gap-6">
          <h1 className="text-lg">
            <EventLabel name="DeadlinePassed" groupName="CMS.Deadline" />
          </h1>
          <p className="text-lg">
            <EventLabel name="DeadlinePassedDescription" groupName="CMS.Deadline" />
          </p>
        </div>
      </div>
    </div>
  );
}
